var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"pb-3":""}},[_c('v-layout',{staticClass:"align-end"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('roles.create.title')))])])])],1),_c('v-flex',[_c('v-card',[_c('RolesForm',{attrs:{"item":null}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }